export default function validateTasks(tasks) {
  try {
    if (!Array.isArray(tasks)) throw new Error("Tasks must be an array");
  } catch (error) {
    console.error("Task validation error:", error);
    return []; // Return empty array on failure
  }
  let lastOpenLidIndex = -1;
  let lastCloseLidIndex = -1;
  let lastDispenseGrainIndex = -1;
  let lastDispenseSoakIndex = -1;
  let lastDispenseSpiceIndex = -1;
  let lastHeatOnIndex = -1;
  console.log(tasks);
  const validTasks = tasks?.map((task, index) => {
    let isValid = true;
    let errorMessage = "";

    // Open Lid validation
    if (task.name === "Open Lid") {
      if (
        lastOpenLidIndex !== -1 &&
        !tasks
          .slice(lastOpenLidIndex + 1, index)
          .some((t) => t.name === "Close Lid")
      ) {
        isValid = false;
        errorMessage = "Open Lid must be closed before opening again.";
      }
      lastOpenLidIndex = index;
    }

    // Close Lid validation
    if (task.name === "Close Lid") {
      if (lastOpenLidIndex === -1) {
        isValid = false;
        errorMessage = "Close Lid must come after Open Lid.";
      } else if (
        tasks
          .slice(lastOpenLidIndex + 1, index)
          .some((t) => t.name === "Close Lid")
      ) {
        isValid = false;
        errorMessage =
          "There should not be another Close Lid between Open Lid and this Close Lid.";
      }
      lastCloseLidIndex = index;
      lastOpenLidIndex = -1; // Reset after closing the lid
    }

    // Dispense Grain validation
    if (task.name === "Dispense Grain") {
      lastDispenseGrainIndex = index;
      if (
        tasks.slice(index + 1).some((t) => t.name === "Pour Grains Cup") &&
        !tasks
          .slice(lastDispenseGrainIndex + 1)
          .some((t) => t.name === "Pour Grains Cup")
      ) {
        isValid = false;
        errorMessage = "Dispense Grain must be followed by Pour Grains Cup.";
      }
    }
    // Dispense Soak validation - skip if no Soak Grain found in entire tasks
    if (task.name === "Soak Grain") {
      lastDispenseSoakIndex = index;
      if (
        tasks.slice(index + 1).some((t) => t.name === "Pour Stainer") &&
        !tasks
          .slice(lastDispenseSoakIndex + 1)
          .some((t) => t.name === "Pour Stainer")
      ) {
        isValid = false;
        errorMessage =
          "Dispense Grain for Soak must be followed by Pour Strainer.";
      }
    }

    // Dispense Spice validation
    if (task.name === "Dispense Spice") {
      lastDispenseSpiceIndex = index;
      if (
        tasks.slice(index + 1).some((t) => t.name === "Pour Spices Cup") &&
        !tasks
          .slice(lastDispenseSpiceIndex + 1)
          .some((t) => t.name === "Pour Spices Cup")
      ) {
        isValid = false;
        errorMessage = "Dispense Spice must be followed by Pour Spices Cup.";
      }
    }

    // Pour Grains Cup validation - skip if no Dispense Grain found in entire tasks
    if (task.name === "Pour Grains Cup") {
      const hasAnyDispenseGrain = tasks.some(
        (t) => t.name === "Dispense Grain"
      );
      if (hasAnyDispenseGrain) {
        if (
          lastDispenseGrainIndex === -1 ||
          tasks
            .slice(lastDispenseGrainIndex + 1, index)
            .some((t) => t.name === "Pour Grains Cup")
        ) {
          isValid = false;
          errorMessage =
            "Pour Grains Cup must be preceded by a Dispense Grain and should not have multiple Pour Grains Cup after it.";
        }
      }
      // If no Dispense Grain found, skip validation (likely removed by dispenser check)
    }

    // Pour Spices Cup validation - skip if no Dispense Spice found in entire tasks
    if (task.name === "Pour Spices Cup") {
      const hasAnyDispenseSpice = tasks.some(
        (t) => t.name === "Dispense Spice"
      );
      if (hasAnyDispenseSpice) {
        if (
          lastDispenseSpiceIndex === -1 ||
          tasks
            .slice(lastDispenseSpiceIndex + 1, index)
            .some((t) => t.name === "Pour Spices Cup")
        ) {
          isValid = false;
          errorMessage =
            "Pour Spices Cup must be preceded by a Dispense Spice and should not have multiple Pour Spices Cup after it.";
        }
      }
      // If no Dispense Spice found, skip validation (likely removed by dispenser check)
    }

    // Tasks requiring Open Lid validation
    if (
      [
        "Pour Grains Cup",
        "Pour Spices Cup",
        "Pour Bowl",
        "Add Oil",
        "Add Sauce/Paste",
        "Add Water",
        "Pour Soaked Grains",
        "Do Saute/Stir",
        "Pour Manual Station Cup",
        "Pour Manual Station Bowl",
        "Pour Stainer",
      ].includes(task.name)
    ) {
      if (
        lastOpenLidIndex === -1 ||
        (lastCloseLidIndex > lastOpenLidIndex && lastCloseLidIndex < index)
      ) {
        isValid = false;
        errorMessage = `${task.name} must be performed after Open Lid and before Close Lid.`;
      }
    }

    // Tasks requiring Close Lid validation (e.g., "Release Steam")
    if (["Steam Release"].includes(task.name)) {
      if (
        lastCloseLidIndex === -1 ||
        lastCloseLidIndex > index ||
        tasks
          .slice(lastCloseLidIndex + 1, index)
          .some((t) => t.name === "Open Lid")
      ) {
        isValid = false;
        errorMessage = `${task.name} must be performed after Close Lid and before any subsequent Open Lid.`;
      }
    }

    // Tasks requiring Heat On validation (e.g., "Cook For (Time)")
    if (["Cook For (Time)"].includes(task.name)) {
      if (lastHeatOnIndex === -1 || lastHeatOnIndex > index) {
        isValid = false;
        errorMessage = `${task.name} must be performed after Heat On. if you are sure that you don't need to heat on, then ignore this message.`;
      }
    }

    // Track the last Heat On task
    if (task.name === "Heat On") {
      lastHeatOnIndex = index;
    }

    // // Cook For (Time) and Steam Release validation
    // if (task.name === "Cook For (Time)" || task.name === "Steam Release") {
    //   if (lastCloseLidIndex === -1 || lastCloseLidIndex > index) {
    //     isValid = false;
    //     errorMessage = `${task.name} must be performed after Close Lid with no Open Lid in between.`;
    //   }
    // }

    return {
      ...task,
      valid: isValid,
      errorMessage,
    };
  });

  return validTasks;
}

export const validateTask = (task) => {
  if (!task) {
    throw new Error("Task is required");
  }

  // Ensure required fields exist
  if (!task.name) {
    throw new Error("Task name is required");
  }

  if (!task.cookIn) {
    throw new Error("Cooking station is required");
  }

  // For ingredient tasks, ensure quantity and position
  if (task.type === "ingredient") {
    if (!task.quantity) {
      throw new Error(`Quantity is required for ingredient: ${task.name}`);
    }
    if (!task.position) {
      throw new Error(`Box position is required for ingredient: ${task.name}`);
    }
    if (!task.isOk) {
      throw new Error(`Invalid task state for ingredient: ${task.name}`);
    }
  }

  return {
    ...task,
    validated: true,
  };
};
